import { IUsageType } from "api/types";

import { useAppState } from "AppState";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import WizardButtonGroup from "components/common/WizardButtonGroup/WizardButtonGroup";
import { ButtonGroup } from "components/common/WizardButtonGroup/WizardButtonGroup.style";
import { CustomerDataContext } from "components/Gates/CustomerDataGate";
import { TabletDataContext } from "components/Gates/TabletDataGate";
import React, { FunctionComponent, useContext, useState } from "react";
import { getApolloContext } from "react-apollo";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";

import UsageTypeSelector from "components/ElementSelector/ElementSelector";
import UsageTypes from "components/ElementSelector/UsageTypes/UsageTypes";
import { shouldHideUsageType } from "components/UsageTypeSelector/utils";

import Text from "components/common/Text/Text";
import styled from "styled-components";

import useReactRouter from "use-react-router";
import { updateCustomerInterestsAndUsageTypes } from "utils/apis";
import { Container, WidgetWrapper } from "./common/TabbedContainers";
import EditProfileTabs, { EditProfileTabNames } from "./tabs/EditProfileTabs";

export default function EditInterestSelection(): JSX.Element {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const { history, location } = useReactRouter();
  const tabletData = useContext(TabletDataContext);
  const { client } = useContext(getApolloContext());
  const loggedCustomer = useContext(CustomerDataContext);

  const {
    locationName,
    availableUsageTypes,
    selectedInterestIdsOnServer,
    selectedUsageTypeIds,
    setSelectedUsageTypeIds,
    setSelectedUsageTypeIdsOnServer,
    localUsageTypeSelectionChanged
  } = useAppState();
  const setSelectedUsageTypes = (changedUsageTypes: IUsageType[]) => {
    setSelectedUsageTypeIds(
      changedUsageTypes.filter(x => x.checked).map(x => x.id)
    );
    setShowSuccessMessage(false);
  };

  const onUpdateUsageTypes = async () => {
    if (client) {
      await updateCustomerInterestsAndUsageTypes(
        client,
        loggedCustomer ? loggedCustomer.authToken : "",
        selectedUsageTypeIds,
        selectedInterestIdsOnServer
      );
      setSelectedUsageTypeIdsOnServer(selectedUsageTypeIds);
      setShowSuccessMessage(true);
    }
  };

  return (
    <PanelLayout
      title={locationName}
      titleSecondary="Edit Usage Types"
      closeButtonHandler
    >
      <Container>
        <EditProfileTabs
          hideUsageTypeTab={shouldHideUsageType(tabletData)}
          hasNoInterests={tabletData && tabletData.hasNoInterests}
          walletStatus={location.state.walletStatus}
          history={history}
          currentTab={EditProfileTabNames.UsageTypes}
        />
        <WidgetWrapper enlarged transparent>
          <>
            <UsageTypeSelector
              title="Choose Your Cannabis Type"
              allElements={availableUsageTypes}
              initialSelectedIds={selectedUsageTypeIds}
              onChange={setSelectedUsageTypes}
              component={<UsageTypes />}
            />
            {localUsageTypeSelectionChanged() && (
              <ButtonGroup>
                <WizardButtonGroup
                  rightCaption="Update"
                  rightClick={onUpdateUsageTypes}
                />
              </ButtonGroup>
            )}
            {showSuccessMessage && (
              <SuccessMessage h4 fullWidth center tertiary>
                We've updated your selection!
              </SuccessMessage>
            )}
          </>
        </WidgetWrapper>
      </Container>
    </PanelLayout>
  );
}

const SuccessMessage = styled(Text)`
  position: absolute;
  bottom: 8vh;
  display: block;
`;



// WEBPACK FOOTER //
// ./src/screens/Main/edit-profile/EditUsageTypeSelection.tsx